import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PatientPrivacyNoticePage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-2815">
      <section className="bg-teal-900 text-white py-16" data-id="element-2816">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2817">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-2818">
            Patient Privacy Notice
          </h1>
          <p className="text-teal-100" data-id="element-2819">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-2820">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2821">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-2822">
            <p className="lead" data-id="element-2823">
              Dentico Dental Clinic Ltd is responsible for your personal data.
            </p>

            <h3 data-id="element-2824">
              When you request an appointment or become our patient, we may
              collect:
            </h3>
            <ul data-id="element-2825">
              <li data-id="element-2826">contact details,</li>
              <li data-id="element-2827">appointment and administrative details,</li>
              <li data-id="element-2828">
                relevant health information needed to provide safe dental care.
              </li>
            </ul>

            <h3 data-id="element-2829">We use your data to:</h3>
            <ul data-id="element-2830">
              <li data-id="element-2831">provide dental care and manage appointments,</li>
              <li data-id="element-2832">communicate about treatment and follow-up,</li>
              <li data-id="element-2833">
                comply with legal, regulatory, and professional obligations.
              </li>
            </ul>

            <h3 data-id="element-2834">Data Sharing</h3>
            <p data-id="element-2835">
              We do not sell your data. We may share data with trusted providers
              (e.g. booking/IT systems, laboratories, advisers) where necessary
              and lawful.
            </p>

            <h3 data-id="element-2836">Your Rights</h3>
            <p data-id="element-2837">
              You have data protection rights under UK law, including access,
              correction, objection/restriction, and withdrawal of consent where
              consent is used.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl mt-8 not-prose" data-id="element-2838">
              <h3 className="text-lg font-bold text-teal-900 mb-4" data-id="element-2839">
                Contact Us
              </h3>
              <div className="space-y-2 text-teal-800" data-id="element-2840">
                <p data-id="element-2841">
                  <strong data-id="element-2842">Email:</strong>{' '}
                  <a href="mailto:info@denticoclinic.co.uk" className="hover:underline" data-id="element-2843">
                    info@denticoclinic.co.uk
                  </a>
                </p>
                <p data-id="element-2844">
                  <strong data-id="element-2845">Address:</strong> 360–364 City Road, London EC1V 2PY
                </p>
                <p data-id="element-2846">
                  <strong data-id="element-2847">Phone:</strong> +44 7345 197820
                </p>
              </div>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}